import {getRouteApi} from "@tanstack/react-router";

export const leadNotesRouteApi = getRouteApi("/_app/sales/leads/$leadId/notes/");
